// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ng-terminal {
  overflow: hidden;
  background: black;
}

.xterm-viewport {
  overflow: auto !important;
}

/* Styles for clickable links from xterm-addon-web-links */
::ng-deep .xterm-link-layer a {
  cursor: pointer;
  text-decoration: underline;
}

::ng-deep .xterm .xterm-screen {
  /* Ensure links are clickable */
}
::ng-deep .xterm .xterm-screen a {
  cursor: pointer;
  text-decoration: underline;
  color: #58a6ff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/terminal/terminal.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA,0DAAA;AACA;EACE,eAAA;EACA,0BAAA;AACF;;AAEA;EACE,+BAAA;AACF;AAAE;EACE,eAAA;EACA,0BAAA;EACA,cAAA;AAEJ","sourcesContent":["ng-terminal {\n  overflow: hidden;\n  background: black;\n}\n\n.xterm-viewport {\n  overflow: auto !important;\n}\n\n/* Styles for clickable links from xterm-addon-web-links */\n::ng-deep .xterm-link-layer a {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n::ng-deep .xterm .xterm-screen {\n  /* Ensure links are clickable */\n  a {\n    cursor: pointer;\n    text-decoration: underline;\n    color: #58a6ff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
